import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:mamichaud@nic.edu">mamichaud@nic.edu</a> or
            <a href="mailto:jmlien@nic.eduu">jmlien@nic.eduu</a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/nic/siteComponents/helpContent.js